// NOTIFICACIÓN DEL SISTEMA/NAVEGADOR — SUPERFICIE ADICIONAL de la capa global de alertas.
// NO es una política nueva: no decide prioridad, no crea alarmas, no consulta el backend, no toca
// ownership ni Take. Sólo ENTREGA lo que AlertsContext ya calculó con la semántica certificada.
// El dedupe se apoya en la identidad autoritativa de la alarma (a.id) vía `tag`, de modo que el
// propio sistema operativo reemplaza en lugar de acumular si algo reintentara la misma alarma.

const soportado = () => typeof window !== "undefined" && "Notification" in window;

let onActivate = null;
// La navegación al caso la resuelve quien tiene el router (GlobalAlertLayer): aquí no se inventa
// routing nuevo ni se reimplementa "Ir al caso".
export const setOnActivate = (fn) => { onActivate = fn; };

export const soporta = () => soportado();

export const permiso = () => (soportado() ? Notification.permission : "no_soportado");

// Sólo se invoca desde un gesto explícito del operador. Si el permiso ya fue decidido
// (granted/denied) NO se vuelve a pedir nunca: no hay loop de solicitud ni prompt por carga.
export async function solicitarPermiso() {
  if (!soportado()) return "no_soportado";
  if (Notification.permission !== "default") return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

// "No está en foreground": pestaña oculta (otra pestaña activa o ventana minimizada) o ventana sin
// foco (navegador detrás de otra aplicación).
export const enSegundoPlano = () => {
  if (typeof document === "undefined") return false;
  if (document.visibilityState === "hidden") return true;
  return typeof document.hasFocus === "function" ? !document.hasFocus() : false;
};

export function notificar({ id, titulo, cuerpo }) {
  if (!soportado() || Notification.permission !== "granted") return false;
  try {
    const n = new Notification(titulo, {
      body: cuerpo,
      tag: `galarya-alarma-${id}`, // identidad autoritativa de la alarma => nunca se apila
      renotify: false,
      requireInteraction: false,
    });
    n.onclick = () => {
      try { window.focus(); } catch { /* el navegador puede negar el foco */ }
      if (onActivate) onActivate(id); // sólo navega: NO ejecuta Take ni cambia estado
      try { n.close(); } catch { /* ya cerrada */ }
    };
    return true;
  } catch {
    return false;
  }
}
